// extracted by mini-css-extract-plugin
export default {"certificate":"G2UaU","deleteButton":"vPTxK"};